import * as yup from "yup";

export const noteSchema = yup.object().shape({
  text: yup.string().required(),
  customerId: yup.string().uuid(),
  productId: yup.string().uuid(),
  invoiceId: yup.string().uuid(),
  notifyCustomer: yup.bool(),
});
